import { render, staticRenderFns } from "./ClientOverview.vue?vue&type=template&id=9b1abcd4"
import script from "./ClientOverview.vue?vue&type=script&lang=ts"
export * from "./ClientOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports